import { gql } from "@apollo/client";

export const GET_WELLNESS_PLAN_LIST = gql`
query getWellnessPlanList {
  fetchWellnessPlan{
   items{
    wellnessplanId
    wellnessId
    isAutoRenewal
    animal_id
    contact_id
    startDate
    endDate
    active
    created_at
    modified_at
    schemaName
    membershipDetails{
      wellnessMembershipDetailsId
      wellnessId
      startCycle
      endCycle
      startDate
      endDate
      active
      created_at
      modified_at
      status
      schemaName
      startDateString
      endDateString
    },
     wellnessplanData{
      wellnessplanId
      wellnessplanName
      billingInterval
      numberOfBillingCycles
      active
      created_at
      modified_at
      price
      schemaName
    }
    wellnessPlanExist
  }
  success
    messages
}
}`;
